import { AppState } from 'services/types';
import { ReEntryWarningState } from './types';

export const selectReEntryWarning = (state: AppState): ReEntryWarningState =>
    state.reEntryWarning;
